import styled from 'styled-components'

export const PlanCardLabel = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12.8px;
  line-height: 19px;

  /* or 150% */

  /* Text/02. Muted */
  color: #6c757d;
`

export const PlanCardValue = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 12.8px;
  line-height: 19px;

  /* or 150% */
  text-align: right;

  /* Text/01. Body */
  color: #212529;
`
